import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const scoreList = (params = '') => Http.get(`/admin/ventures/scores${serialize(params)}`)
export const scoreRecalc = (pitchId) => Http.post(`/admin/ventures/scores/${pitchId}/recalc`)
